<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">
						<i class="sk-icon-receipt-solid"></i>
						Receipt
					</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-subtitle">
						<div class="sk-scrollbar">
							<ReceiptItem
								class="cart-checkout-item"
								v-for="item in cart"
								:key="item.id"
								:item="item"
								:data-cy="`checkout-item-${item.id}`"
								:editable="false"
							/>
						</div>
						<div class="fees">
							<div class="additional-fee">
								Subtotal
								<span class="additional-fee-price">
									{{ subtotal | currency }}
								</span>
							</div>
							<div class="additional-fee">
								Tax & Fees
								<span class="additional-fee-price">
									{{ totalTaxFees | currency }}
								</span>
							</div>
							<div class="additional-fee" v-if="showDeliveryFee">
								Gate Delivery
								<span class="no-fee" v-if="noDeliveryFee">
									FREE
								</span>
								<span class="additional-fee-price" v-else>
									{{ deliveryFee | currency }}
								</span>
							</div>
							<div v-if="showTip" class="additional-fee">
								Tip
								<span
									class="additional-fee-price"
									data-cy="tip-amount"
								>
									{{ totalTip | currency }}
								</span>
							</div>
							<div v-if="discount > 0" class="additional-fee">
								Discount
								<span
									class="additional-fee-price"
									data-cy="discount-amount"
								>
									-{{ discount | currency }}
								</span>
							</div>
							<div class="total-price">
								<span>Total</span>
								<span>{{ totalPrice | currency }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 0px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--gR-white2);
}

.modal-subtitle {
	font-size: 12px;
	margin: 0px;
	width: 100%;
}

.modal-body button.button.button-primary {
	max-width: calc(100% - 5px);
	margin: 0 5px;
}

.cart-checkout-item {
	border-bottom: 1px solid var(--gR-white2);
	flex-shrink: 0;
}

.sk-scrollbar {
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	height: 100%;
}

.additional-fee {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: var(--sk-grey);
	padding-bottom: 12px;
}

.additional-fee .additional-fee-price {
	color: var(--sk-grey);
}

.no-fee {
	color: var(--gR-teal-70);
	font-weight: 500;
}

.total-price {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-top: 1px solid var(--gR-white2);
	padding: 12px 0px;
}

.total-price span {
	font-weight: 600;
	font-size: 12px;
	color: var(--gR-base-80);
}

.fees {
	padding: 30px 18px 18px 18px;
}
</style>

<script>
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import ReceiptItem from "@/components/success/ReceiptItem.vue"

export default {
	name: "ReceiptModal",
	mixins: [currencyFilterMixin, mobileResponsivenessMixin],
	components: {
		ReceiptItem
	},
	computed: {
		showDeliveryFee() {
			return this.$store.getters.showCartDeliveryFee
		},
		noDeliveryFee() {
			return this.deliveryFee <= 0
		},
		deliveryFee() {
			return this.$store.state.receipt.delivery_fee
		},
		showTip() {
			if (
				this.$store.getters.isAirport &&
				this.$store.state.orderStatus.delivery_mode ==
					DeliveryMode.LOCKER
			) {
				return false
			}
			return true
		},
		subtotal() {
			return this.$store.state.receipt.price
		},
		totalPrice() {
			return this.$store.state.orderStatus.price
		},
		totalTip() {
			return this.$store.state.receipt.tip
		},
		totalTaxFees() {
			return (
				this.$store.state.receipt.tax +
				this.$store.state.receipt.service_fee
			)
		},
		discount() {
			return this.$store.state.receipt.discount
		},
		cart() {
			if (this.$store.state.orderStatus.sub_orders) {
				let cart = []
				this.$store.state.orderStatus.sub_orders.map((subOrder) => {
					let products = subOrder.products
					let restaurant = subOrder.rest_name
					products.map((product) => {
						let brandId =
							this.$store.getters.menuBrandsMap[product.menu_id]
						let brand = this.$store.state.brands.find(
							(brand) => brandId == brand.id
						)
						let item = {
							name: product.name,
							menu_id: product.menu_id,
							meta: product.meta,
							quantity: product.quantity,
							subtotal: product.subtotal,
							id: product.id,
							brand: brand ? brand.name : restaurant
						}
						cart.push(item)
					})
				})
				return cart
			}
		}
	},
	methods: {
		open() {
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
